export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Чехол для iPhone 5 с подставкой</h3><p>Чехол для iPhone 5 сделан из супер прочного и тонкого пластика. Сломать такой чехол практически невозможно. Поверхность чехла покрыта блестящим ламинированием, что придает рисунку потрясающую насыщенность и яркость.</p><p>Страна производства: Великобритания.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Рисунок наносится непосредственно на чехол и запекается при очень высокой температуре в специальной печи. Для нанесения рисунка используются уникальное для России запатентованное оборудование и расходные материалы, которые позволяют запечатать весь чехол, включая боковые стороны.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
